/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query LBRRoutePlanReadQuery($routePlanId: ID) {
  LBRRoutePlanRead(routePlanId: $routePlanId) {
    id,
    createdAt,
    updatedAt,
    message,
    loadBalancerConfiguration,
    status,
    Mcc {
      mcc,
      countryName,
      Mnc {
        mnc,
        network
      }
    },
    Mnc {
      id,
      mnc,
      network
    },
    LBRRoute {
      displayName
    },
    VendorAccount {
      id,
      displayName
    }
   
  }
}
`
